<!-- 采购订单数据操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField" :rules="$common.getFormItemRules(formOneValue, sendDataInfo)">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <!-- 日期 -->
                                                    <df-date class="form_codition" v-if="formOneValue.entityField == 'psomBuydate'" @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                        v-model="sendDataInfo[formOneValue.entityField]" :isShowLong="false"
                                                        :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0&&dataActionBox.actionType ==0 && formOneValue.isUpdate == 0)">
                                                    </df-date>
                                                    <df-date class="form_codition" v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]"
                                                        @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                        :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0&&dataActionBox.actionType ==0&& formOneValue.isUpdate == 0)">
                                                    </df-date>
                                                    <!-- 检索方案 -->
                                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                        :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
                                                        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @input="$common.clearSearch(sendDataInfo, formOneValue.setField,formOneValue.entityField)" @clear="$common.clearSearch(sendDataInfo, formOneValue.setField)"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId,formOneValue.isIndex,formOneValue.entityField,formOneValue.setField)"
                                                            :disabled="(formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0&&dataActionBox.actionType ==0 && formOneValue.isUpdate == 0 && isTiQu))&&(sendDataInfo[formOneValue.entityField]?true:false)">
                                                            <el-button @click="openSearch(formOneValue.searchId,formOneValue.isIndex,formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                :disabled="(formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0&&dataActionBox.actionType ==0 && formOneValue.isUpdate == 0 && isTiQu))&&(sendDataInfo[formOneValue.entityField]?true:false)">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                    <el-select class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0&&dataActionBox.actionType ==0 && formOneValue.isUpdate == 0)" @change="$forceUpdate()"
                                                        v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 账期 -->
                                                    <el-input @mousewheel.native.prevent class="form_codition" @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" type="number"
                                                        v-else-if="formOneValue.entityField == 'credit'"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0&&dataActionBox.actionType ==0 && formOneValue.isUpdate == 0)"
                                                        v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    <!-- string类型 -->
                                                    <el-input class="form_codition" @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" v-else
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0&&dataActionBox.actionType ==0 && formOneValue.isUpdate == 0)"
                                                        v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" :key="formOneKey">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{ sendDataInfo[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo[formOneValue.entityField]">
                                                            {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                                                        </span>
                                                    </span>
                                                    <span
                                                        v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay' || formOneValue.entityField == 'isMag'">{{sendDataInfo[formOneValue.entityField] == 1 ? "是" : "否"}}</span>
                                                    <span
                                                        v-else-if="formOneValue.fieldType == 'formatter'">{{getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)}}</span>
                                                    <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细信息 -->
                                    <div>
                                        <el-form :inline="true" size="mini">
                                            <div v-if="dataActionBox.actionType != 2" id="operateBtn">
                                                <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                                                    新增</el-button>
                                                <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                                </el-button>
                                                <el-button type="primary" size="mini" @click="copyDetails()">复制
                                                </el-button>
                                                <el-button type="primary" size="mini" @click="lookLicence()">查看证照
                                                </el-button>
                                                <el-button v-if="tabForm[0].isExtract==1" @click="openExtSearch('629899519725569')" size="mini" type="primary">提取外部订单</el-button>
                                                <el-button v-if="tabForm[0].isExtract==1" @click="openExtSearch('621527362763711')" size="mini" type="primary">提取寄售订单</el-button>
                                                <el-button @click="openExtSearch('949599709200712')" size="mini" type="primary">提取合同</el-button>
                                                <el-button @click="openExtSearch('538560780537856')" size="mini" type="primary">提取采购计划</el-button>
                                                <el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
                                                <el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
                                                <el-button type="primary" size="mini" @click="addLicence()">临时证照维护</el-button>
                                                <el-dropdown style="margin-left: 5px;" v-if="$store.state.btnlist" trigger="click">
                                                    <el-button type="primary">
                                                        辅助功能<i class="el-icon-arrow-down el-icon--right"></i>
                                                    </el-button>
                                                    <template #dropdown>
                                                        <el-dropdown-menu slot="dropdown">
                                                            <el-dropdown-item v-for="(item, index) in JSON.parse($store.state.btnlist)" :key="index" @click.native="Historical(item.mdSource, item.mdName)">{{
                                                                    item.mdName }}</el-dropdown-item>
                                                        </el-dropdown-menu>
                                                    </template>
                                                </el-dropdown>

                                                <el-link :underline="false" type="danger" style="margin-left: 10px">
                                                    (Alt+F1：新增明细</el-link>
                                                <el-link :underline="false" type="danger" style="margin-left: 10px">
                                                    Alt+F2/Delete：删除明细)</el-link>
                                            </div>
                                            <el-table size="mini" class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.pisOrderDetail" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                                @selection-change="handleSelectionChange" border style="width: 100%" :height="mxHeight">
                                                <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                                    <template slot-scope="scope">
                                                        <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                            <i class="el-icon-thumb"></i>
                                                        </el-radio>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="序号" type="index" width="50"></el-table-column>
                                                <template v-for="(formOneValue, formOneKey) in mxForm.jurconfigform">
                                                    <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" :key="formOneKey"
                                                        v-if="formOneValue.isShow == 1">
                                                        <template slot-scope="scope">
                                                            <el-input v-if="formOneValue.fieldType == 'search' &&dataActionBox.actionType != 2&& formOneValue.isChange == 1" clearable
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField,true)"
                                                                :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 && formOneValue.isChange == 1">
                                                                <el-button @click="openSearch(formOneValue.searchId,scope.$index,formOneValue.entityField,formOneValue.setField,formOneValue.focusField,true)" slot="append"
                                                                    icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                                </el-button>
                                                            </el-input>
                                                            <!-- 数量 -->
                                                            <el-input @mousewheel.native.prevent @blur="blurwoadPnumber(scope.$index)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)"
                                                                @input="calculatePrice(5, scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'psodPacknum' &&
                                                                dataActionBox.actionType != 2 && formOneValue.isChange == 1
                                                                " type="number" v-model="sendDataInfo.pisOrderDetail[scope.$index].psodPacknum">
                                                            </el-input>

                                                            <!-- 单价 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(1, scope.$index)"
                                                                :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'price' &&dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                :maxlength="$store.state.inputLength" type="number" v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>

                                                            <!-- 含税价 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)"
                                                                @change="doCheckPrice(2, scope.$index, formOneValue.entityField, formOneValue.focusField)" @input="calculatePrice(2, scope.$index)" :ref="formOneValue.entityField"
                                                                v-else-if="formOneValue.entityField == 'psprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>

                                                            <!-- 金额 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(3, scope.$index)"
                                                                :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'money' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                :maxlength="$store.state.inputLength" type="number" v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>

                                                            <!-- 含税金额 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(4, scope.$index)"
                                                                :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'psmoney' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                :maxlength="$store.state.inputLength" type="number" v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 折前价格 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice('disPreprice', scope.$index)"
                                                                :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'disPreprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                :maxlength="$store.state.inputLength" type="number" v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 协议价 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField"
                                                                @input="calculatePrice('agreementPrice', scope.$index)" v-else-if="formOneValue.entityField == 'agreementPrice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                :maxlength="$store.state.inputLength" type="number" v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 价格策略 -->
                                                            <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField"
                                                                v-else-if="formOneValue.entityField.indexOf('levePrice')!=-1 && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 备注 -->
                                                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField"
                                                                v-else-if="formOneValue.entityField == 'psodRemark' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 最低批次价格 -->
                                                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField"
                                                                v-else-if="formOneValue.entityField == 'lotMinPrice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 含税原价 -->
                                                            <el-input @input="calculatePrice(6, scope.$index)" @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField"
                                                                v-else-if="formOneValue.entityField == 'orPsprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <!-- 不含税原价 -->
                                                            <el-input @input="calculatePrice(7, scope.$index)" @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField"
                                                                v-else-if="formOneValue.entityField == 'orPrice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField"
                                                                v-else-if="dataActionBox.actionType != 2 && formOneValue.isChange == 1" v-model="sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]">
                                                            </el-input>
                                                            <span v-else-if="formOneValue.isRift == 1">
                                                                <a @click="toDetail(sendDataInfo.pisOrderDetail[scope.$index][formOneValue.riftField])">{{sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]}}</a>
                                                            </span>
                                                            <span v-else>{{sendDataInfo.pisOrderDetail[scope.$index][formOneValue.entityField]}}</span>
                                                        </template>
                                                    </el-table-column>
                                                </template>
                                            </el-table>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :isRepetition="isRepetition" :isRepetitionList="isRepetitionList" :isProp="'bgmId'" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth"
                @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <div>
            <el-dialog :title="exTitle" :destroy-on-close="true" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
                <ExtractionScheme v-if="DialogExtract" ref="extractionScheme" :interceptFlag="interceptFlag" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
            </el-dialog>
        </div>
        <el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
            <initDataUpload :url="url" :parentSearchData="importObj" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
        <historicalOrders ref="HistoricalOrders" />
        <component :is="currentComponent" :ref="currentComponent"></component>
        <el-dialog title="新增临时证照" :visible.sync="licenseexpiShow" width="50%" append-to-body modal-append-to-body>
            <licenseexpiAdd ref="licenseexpiAdd" @close="closeLicenseexpi"></licenseexpiAdd>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import licenseexpiAdd from "./licenseexpiAdd.vue";
export default {
    name: "purchaseOrderAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
        licenseexpiAdd,
    },
    data() {
        //这里存放数据
        return {
            currentComponent: "",
            showDialog: false,
            showDialog1: false,
            flags: false,
            flag: -1,
            blurData: "",
            dialogList: [],
            mxHeight: 0,
            guaranteeBeginDay: "",
            detailRules: false, //规则
            selectDataTable: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            detaislDataInfo: {},
            selectedDetailsIndex: 0,
            value1: "",
            sendDataInfo: {
                smId: "",
            },
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            goodsList: [],
            storageRoomList: [],
            salesmanList: [],
            editDateilsIndex: "",
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            ppId: "orderId",
            DialogVisible: false,
            interceptFlag: false,//提取是否拦截
            DialogExtract: false,
            newFormDataList: [],
            seType: "",
            smId: "",
            parentSearchData: {
                smId: "",
                orderType: 0, //	订单类型0.药品1.器械
            },
            isLoaded: false,
            orderId: "",
            printsouce: "",
            seIndex: 0, //选中索引
            isBuyer: 0,
            tabForm: [], // tab循环的主表单
            sField: "", // 赋值字段
            fField: "", //焦点字段
            nosField: "", // 不可赋值字段
            mxForm: [],
            footForm: [],
            selectedRow: [],
            isTiQu: true,
            stNameFlag: false,//判断库房是在表单里选择的还是明细里选择的
            isRepetitionList: [],
            isRepetition: false,
            importShow: false,
            importType: "",
            url: "",
            importObj: {},
            licenseexpiShow: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.pisOrderDetail": {
            handler: function (newValue, oldValue) {
                // 初始化总计值
                let totalMoney = 0;
                let totalNumber = 0;
                let totalAgreementPrice = 0;
                const totalCount = newValue.length;

                // 批量处理数组数据，减少重复计算
                for (let i = 0; i < newValue.length; i++) {
                    const item = newValue[i];

                    // 数据清理：将null值替换为空字符串
                    for (const key in item) {
                        if (item[key] === null) {
                            item[key] = "";
                        }
                    }

                    // 统一处理数值字段的格式化，减少重复调用
                    this.$set(item, 'disPreprice', this.$common.updataNum('disPreprice', item).disPreprice);
                    this.$set(item, 'agreementPrice', this.$common.updataNum('agreementPrice', item).agreementPrice);
                    this.$set(item, 'lotMinPrice', this.$common.updataNum('lotMinPrice', item).lotMinPrice);
                    this.$set(item, 'psodPacknum', this.$common.updataNum('psodPacknum', item).psodPacknum);
                    this.$set(item, 'psprice', this.$common.updataNum('psprice', item).psprice);

                    if (item.orPsprice !== undefined) {
                        this.$set(item, 'orPsprice', this.$common.updataNum('orPsprice', item).orPsprice);
                    }

                    if (item.orPrice !== undefined) {
                        this.$set(item, 'orPrice', this.$common.updataNum('orPrice', item).orPrice);
                    }

                    // 批量处理价格等级字段
                    for (let index = 0; index < 9; index++) {
                        const fieldName = `levePrice${index + 1}`;
                        this.$set(item, fieldName, this.$common.updataNum(fieldName, item)[fieldName]);
                    }

                    // 数据校验和修正负值
                    if (item.psodPacknum < 0) {
                        this.sendDataInfo.pisOrderDetail[i].psodPacknum = 0;
                    }

                    if (item.price === "") {
                        this.sendDataInfo.pisOrderDetail[i].price = 0;
                    } else if (item.price < 0) {
                        this.sendDataInfo.pisOrderDetail[i].price = 0;
                    }

                    if (item.money < 0) {
                        this.sendDataInfo.pisOrderDetail[i].money = 0;
                    }

                    if (item.psprice < 0) {
                        this.sendDataInfo.pisOrderDetail[i].psprice = 0;
                    }

                    if (item.psmoney < 0) {
                        this.sendDataInfo.pisOrderDetail[i].psmoney = 0;
                    }

                    // 累加计算总金额和总数
                    totalMoney = this.$common.getDecimalInfo(3, NP.plus(totalMoney, item.psmoney));
                    totalNumber = this.$common.getDecimalInfo(1, NP.plus(totalNumber, item.psodPacknum));
                    // 累加计算总协议价 协议价*采购数量
                    totalAgreementPrice = this.$common.getDecimalInfo(3, NP.plus(totalAgreementPrice, NP.times(item.agreementPrice || 0, item.psodPacknum || 0)));
                }

                // 一次性更新总计信息
                this.sendDataInfo.totalMoney = totalMoney;
                this.sendDataInfo.totalNumber = totalNumber;
                this.sendDataInfo.totalCount = totalCount;
                // 使用 $set 保证后端未配置该字段时底部合计也能响应式刷新
                this.$set(this.sendDataInfo, "totalAgreementPrice", totalAgreementPrice);
            },
            deep: true,
        },
        "sendDataInfo.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.sendDataInfo.smId = "";
                    this.sendDataInfo.salesName = "";
                    this.sendDataInfo.salesId = "";
                    this.parentSearchData.smId = "";
                }
            },
            deep: true,
        },
        "sendDataInfo.isPay": {
            handler: function (newValue, oldValue) {
                if (newValue == 0) {
                    this.sendDataInfo.sbiName = "";
                    this.sendDataInfo.sbiId = "";
                    this.sendDataInfo.sbiNumber = "";
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "sbiName" ||
                            item.entityField == "sbiNumber"
                        ) {
                            item.isShow = 0;
                        }
                    });
                } else {
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "sbiName" ||
                            item.entityField == "sbiNumber"
                        ) {
                            item.isShow = 1;
                        }
                    });
                }
                this.$forceUpdate();
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        addLicence(){
            this.licenseexpiShow = true;
        },
        //含税价拦截
        doCheckPrice(cate, index, entityField, focusField) {
            var info = this.sendDataInfo.pisOrderDetail[index];
            let pspriceObj = {
                bgmId: info.bgmId || null, //商品Id
                psprice: info.psprice, //商品价格
                priceListId: info.priceListId || null, //价目表Id
            };
            this.$http.puCheckPrice(pspriceObj).then((res) => {
                if (res.status == 200) {
                    this.calculatePrice(cate, index);
                } else if (res.status == 300) {
                    this.$message({
                        message: res.message,
                        type: "warning",
                    });
                    this.sendDataInfo.pisOrderDetail[index].psprice = info.psprice;
                } else {
                    this.$refs[entityField][index].focus();
                    this.$message({
                        message: res.message,
                        type: "error",
                    });
                    this.sendDataInfo.pisOrderDetail[index].psprice = 0;
                    this.calculatePrice(cate, index);
                    if (this.sendDataInfo.pisOrderDetail.filter(item => item.bgmId == "" || item.bgmName == "").length > 0) {
                        this.sendDataInfo.pisOrderDetail.splice(this.sendDataInfo.pisOrderDetail.length - 1, 1)
                    }
                }
            });
        },
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(val) {
            this.importShow = false
            if (val.list.length > 0) {
                var list = []
                val.list.forEach(item => {
                    list.push({})
                    for (const key in item) {
                        this.$set(list[list.length - 1], key, item[key])
                    }
                })
                this.sendDataInfo.pisOrderDetail.push(...list)
            }
        },
        exportTemplate() {
            window.location.href = `${window.global_config.BASE_URL}/pisplanorder/downPisDetailExcel`
        },
        importDetails() {
            this.$refs['sendDataInfo'].validate((valid) => {
                if (valid) {
                    this.importType = 'exportPisDetail'
                    this.url = 'pisplanorder/exportPisDetail'
                    this.importObj.formId = this.mxForm.jciId //表单ID
                    this.importObj.unitId = this.sendDataInfo.smId //单位ID
                    this.importObj.salesId = this.sendDataInfo.salesId //对方业务员ID
                    this.importShow = true
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'smIntype') {
                this.dictionariesDatas.forEach(item => {
                    if (item.diValue == val) {
                        str = item.diName
                    }
                })
            } else if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        async blur(focusField, index, ownField, title) {
            setTimeout(async () => {
                //失去焦点事件和点击事件冲突addDetail
                if (title == "blur") {
                    this.blurData = title;
                } else {
                    this.blurData = "";
                }
                if (this.flags) {
                    this.flags = false;
                    return;
                }
                this.fField = focusField;
                this.seIndex = index;
                this.seType = ownField;
                let params = {
                    formId: this.formDataList[1].jciId,
                    num: "",
                    psprice: "",
                };
                if (ownField == "psodPacknum") {
                    params.num = this.sendDataInfo.pisOrderDetail[index][ownField];
                } else if (ownField == "psprice") {
                    params.psprice =
                        this.sendDataInfo.pisOrderDetail[index][ownField];
                }
                if (ownField) {
                    await this.$http.interceptPuNumPsPrice(params).then((res) => {
                        this.flag = -1;
                        this.dialogList = []
                        if (res.result != null && res.result.length > 0) {
                            res.result.forEach(item => {
                                this.dialogList.push(item)
                            })
                            this.flag = this.dialogList.findIndex(
                                (item) => item.level == 0
                            );
                        } else {
                            console.log(
                                this.sendDataInfo.pisOrderDetail[index][ownField]
                            );
                            if (
                                this.sendDataInfo.pisOrderDetail[index][ownField] != 0
                            ) {
                                this.tableNextFocus(this.fField, this.seIndex);
                            }
                        }
                        if (this.flag == 0) this.showDialog1 = true;
                        if (this.flag != -1) {
                            this.$nextTick(() => {
                                // document.getElementById("qrBtn")?.focus();
                                if (title != "blur") {
                                    this.flags = true;
                                }
                                this.sendDataInfo.pisOrderDetail[index][ownField] = 0;
                                this.$refs[ownField][index].blur();
                            });
                        }
                    });
                }
            }, 150);
        },
        intercept() {
            this.showDialog1 = false;
            if (this.flag == -1) {
                this.tableNextFocus(this.fField, this.seIndex);
            } else {
                this.$nextTick(() => {
                    this.$refs[this.seType][this.seIndex].focus();
                });
            }
        },
        Historical(url, title) {
            this.currentComponent = url;
            var historicalOrder = {
                smName: "",
                smId: "",
                bgmName: "",
                bgmId: "",
            };
            if (this.currentComponent == "historicalOrders") {
                historicalOrder.smName = this.sendDataInfo["smName"];
                historicalOrder.smId = this.sendDataInfo["smId"];
            }
            if (this.sendDataInfo["pisOrderDetail"].length > 0) {
                historicalOrder.bgmId =
                    this.sendDataInfo["pisOrderDetail"][
                        this.selectedDetailsIndex
                    ].bgmId;
                historicalOrder.bgmName =
                    this.sendDataInfo["pisOrderDetail"][
                        this.selectedDetailsIndex
                    ].bgmName;
            }
            this.$nextTick(() => {
                this.$refs[this.currentComponent].openBox(historicalOrder, title);
            });
        },
        //触发提取
        openExtSearch(id) {
            this.interceptFlag = false
            if (id == "629899519725569") {
                this.ppId = "orderId";
            } else if (id == "949599709200712") {
                this.interceptFlag = true
                this.ppId = "conmId";
            } else if (id == "538560780537856") {
                this.ppId = "pmId";
            } else if (id == "621527362763711") {
                this.ppId = "psextmId";
            }
            this.exId = id;
            this.DialogExtract = true;
        },
        //提取返回
        async getDataByChen(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                this.$http
                    .checkVendorLicense({
                        //校验购进单位
                        formId: this.formDataList[0].jciId, //表单ID
                        unitId: val.smId || "", //单位ID
                    })
                    .then((res) => {
                        console.log(res);
                        if (res && res.status == 200) {
                            let flag = -1;
                            this.dialogList = []
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                flag = this.dialogList.findIndex(
                                    (item) => item.level == 0
                                );
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                for (let key in val) {
                                    if (key == "arrlistbychen") {
                                        this.sendDataInfo.pisOrderDetail =
                                            val.arrlistbychen;
                                    } else {
                                        if (
                                            (key == "opmName" && val[key] == null) ||
                                            (key == "depName" && val[key] == null) ||
                                            (key == "depId" && val[key] == null) ||
                                            (key == "opmId" && val[key] == null)
                                        ) {
                                            this.sendDataInfo[key] =
                                                this.sendDataInfo[key];
                                        } else if (val[key] == null || val[key] === "") {
                                        } else {
                                            this.sendDataInfo[key] = val[key];
                                        }
                                        this.sendDataInfo.totalMoney = 0;
                                        this.sendDataInfo.totalNumber = 0;
                                        this.sendDataInfo.totalCount = 0;
                                    }
                                }
                                this.sendDataInfo.pisOrderDetail.forEach(
                                    (item, index) => {
                                        this.sendDataInfo.totalMoney += item.rrdPsmoney;
                                        this.sendDataInfo.totalNumber += item.oldNum;
                                        this.calculatePrice(5, index);
                                    }
                                );
                                this.parentSearchData.smId = val.smId;
                                this.sendDataInfo.totalCount = this.sendDataInfo.pisOrderDetail.length;
                                if (!val.salesName || !val.salesId || !val.recName || !val.recId) {
                                    this.$http.queryDefaultSales({
                                        ids: [val.smId]
                                    }).then((res) => {
                                        if (res && res.status == 200) {
                                            for (const key in res.result) {
                                                if (!this.sendDataInfo[key]) {
                                                    this.sendDataInfo[key] = res.result[key] || "";
                                                }
                                            }
                                        }
                                    })
                                }
                                this.isTiQu = true;
                                this.DialogExtract = false;

                                this.$nextTick(() => {
                                    this.selectedDetailsIndex = 0;
                                    let refsElTable = this.$refs.mxTableRef;
                                    refsElTable.clearSelection();
                                    refsElTable.toggleRowSelection(
                                        this.sendDataInfo.pisOrderDetail[
                                        this.selectedDetailsIndex
                                        ]
                                    );
                                    this.nextFocus(0);
                                });
                            } else {
                                this.showDialog = true;
                            }
                        }
                    });
            }
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },

        // 查看证照
        lookLicence() {
            if (this.sendDataInfo.smId == "") {
                return this.$message({
                    message: "请先选择供货单位",
                    type: "warning",
                });
            }
            this.$parent.$parent.toDetail(this.sendDataInfo.smId);
        },
        // 临时证照维护
        addLicence() {
            this.licenseexpiShow = true;
            this.$nextTick(() => {
                if (this.$refs.licenseexpiAdd) {
                    this.$refs.licenseexpiAdd.init();
                }
            });
        },
        closeLicenseexpi() {
            this.licenseexpiShow = false;
        },
        closeChild() {
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
        },
        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {};
            this.selectedDetailsIndex = row.rowIndex;
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {};
            if (row.bgColor && row.bgColor != "")
                rowBackground.backgroundColor = row.bgColor;
            return rowBackground;
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        // 输入框切换焦点
        nextFocus(index, fField) {

            if (index >= this.inputel.length - 1) {
                this.addDetail("sendDataInfo");
                return;
            }
            if (fField == "keydown") {
                this.addDetail("sendDataInfo");
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.inputel[aindex].focus();
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },

        // 表格切换焦点方法
        tableNextFocus(field, index) {
            if (field == "keydown") {
                this.addDetail("sendDataInfo");
                if (this.sendDataInfo.pisOrderDetail[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    return;
                }
                // if(this.blurData != 'blur'){
                //     this.addDetail("sendDataInfo");
                // }

                return;
            }
            this.$refs[field][index].focus();
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                console.log("选中的数据", this.actionData);
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        toDetail(orderId) {
            // console.log(this.$parent.$parent.$parent);
            this.$parent.$parent.$parent.toDetail(orderId);
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex);
            });
        },
        // 表格赋值字段
        mxParamValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo.pisOrderDetail[this.seIndex][item] = val[item];
            });
            this.sendDataInfo.pisOrderDetail.splice(1, 0);
            // this.$nextTick(() => {
            // 	this.tableNextFocus(this.fField, this.seIndex);
            // });
        },
        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        //提取返回
        changeInputModel(val) {
            console.log("返回", val, this.seType);
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                addEventListener("keyup", this.keyUp); //创建监听键盘事件
                if (val.depId) {
                    this.sendDataInfo.depId = val.depId;
                    this.sendDataInfo.depName = val.depName;
                }
                if (this.seType == "bgmName") {
                    var bgiTypeArr = [];
                    var bgmIds = [];
                    var repeatBgmId = [];
                    this.sendDataInfo.pisOrderDetail.forEach((v) => {
                        if (v.bgmName != "" && v.bgmId != "") {
                            bgiTypeArr.push(v.bgiType);
                            repeatBgmId.push(v.bgmId);
                        }
                    });
                    if (Array.isArray(val)) {
                        val.forEach((item) => {
                            bgmIds.push(item.bgmId);
                            bgiTypeArr.push(item.bgiType);
                            repeatBgmId.push(item.bgmId);
                        });
                    } else {
                        bgiTypeArr.push(val.bgiType)
                        bgmIds = [val.bgmId];
                        repeatBgmId.push(val.bgmId);
                    }
                    this.$http
                        .checkPurchasingScope({
                            //校验明细商品
                            formId: this.mxForm.jciId, //表单ID
                            unitId: this.sendDataInfo.smId, //单位ID
                            bgmId: bgmIds, //商品id
                            repeatBgmId: repeatBgmId,//重复商品id
                            ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId, //组织ID
                            salesId: this.sendDataInfo.salesId, //对方业务员ID
                            bgiTypes: bgiTypeArr, //药品类型
                        }).then((res) => {
                            if (res && res.status == 200) {
                                this.flag = -1;
                                this.dialogList = []
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                if (
                                    this.dialogList != null &&
                                    this.dialogList.length > 0
                                ) {
                                    this.flag = this.dialogList.findIndex(
                                        (item) => item.level == 0
                                    );
                                    this.showDialog = true;
                                }
                                if (this.flag == -1) {
                                    if (Array.isArray(val)) {
                                        this.bgmSelect(val);
                                        return;
                                    }
                                    for (let key in val) {
                                        this.sendDataInfo.pisOrderDetail[this.seIndex][key] = val[key];
                                    }
                                    this.sendDataInfo.pisOrderDetail[this.seIndex].psodPsdvolume = val.rjXl;
                                    this.sendDataInfo.pisOrderDetail[this.seIndex].psodPsnvolume = val.stockNum;
                                    this.sendDataInfo.pisOrderDetail[this.seIndex].psodPsupperlimit = val.limdHighnum;
                                    this.sendDataInfo.pisOrderDetail[this.seIndex].psodPslowerlimit = val.limdLownum;
                                    if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                                        this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stName', this.sendDataInfo.stName);
                                        this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stId', this.sendDataInfo.stId);
                                    }
                                    this.calculatePrice(5, this.seIndex)
                                    if (!this.dialogList.length) {
                                        this.tableNextFocus(this.fField, this.seIndex);
                                    }
                                } else {
                                    this.showDialog = true;
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.$set(
                                    this.sendDataInfo.pisOrderDetail,
                                    this.seIndex,
                                    JSON.parse(JSON.stringify(this.detaislDataInfo))
                                );
                                if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                                    this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stName', this.sendDataInfo.stName);
                                    this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stId', this.sendDataInfo.stId);
                                }
                            }
                        }).catch((rej) => {
                            this.lineMessageBox(rej);
                            for (let key in this.sendDataInfo.pisOrderDetail[this.seIndex]) {
                                this.sendDataInfo.pisOrderDetail[this.seIndex][key] = "";
                            }
                            if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stName', this.sendDataInfo.stName);
                                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stId', this.sendDataInfo.stId);
                            }
                        });
                } else if (this.seType == "smName") {
                    var flag = -1;
                    this.$http.checkVendorLicense({
                        //校验购进单位
                        formId: this.formDataList[0].jciId, //表单ID
                        unitId: val.smId, //单位ID
                    }).then((res) => {
                        if (res && res.status == 200) {
                            this.dialogList = []
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                flag = this.dialogList.findIndex(
                                    (item) => item.level == 0
                                );
                                this.showDialog = true;
                            }

                            if (flag == -1) {
                                this.parentSearchData.smId = val.smId;
                                this.sendDataInfo.smName = val.smName;
                                this.sendDataInfo.smId = val.smId;
                                this.$http.queryDefaultSales({
                                    ids: [val.smId]
                                }).then((res) => {
                                    if (res && res.status == 200) {
                                        var valObj = {
                                            ...val,
                                            ...res.result,
                                        }
                                        if (valObj.salesId && valObj.salesName && this.sField.indexOf('salesId') != -1 && this.sField.indexOf('salesName') != -1) {
                                            this.$http.checkSalesLicense({
                                                //校验供应商业务员
                                                formId: this.formDataList[0].jciId, //表单ID
                                                salesId: valObj.salesId, //业务员ID
                                            }).then((res) => {
                                                if (res && res.status == 200) {
                                                    let flag = -1;
                                                    if (res.result != null && res.result.length > 0) {
                                                        res.result.forEach(item => {
                                                            this.dialogList.push(item)
                                                        })
                                                        flag = this.dialogList.findIndex(
                                                            (item) => item.level == 0
                                                        );
                                                        this.showDialog = true;
                                                    }
                                                    if (flag == -1) {
                                                        this.paramValue(valObj);
                                                    }
                                                } else {
                                                    this.lineMessageBox(res);

                                                    return false;
                                                }
                                            }).catch((rej) => {
                                                this.lineMessageBox(rej);
                                            });
                                        } else {
                                            this.paramValue(val);
                                        }
                                    } else {
                                        this.paramValue(val);
                                    }
                                }).catch((rej) => {
                                    this.lineMessageBox(rej);
                                });

                            } else {
                                this.showDialog = true;
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.parentSearchData.smId = "";
                            this.clearValue();
                            return false;
                        }
                    })
                        .catch((rej) => {
                            this.lineMessageBox(rej);

                            this.parentSearchData.smId = "";
                            this.clearValue();
                        });

                } else if (this.seType == "salesName") {
                    this.$http.checkSalesLicense({
                        //校验供应商业务员
                        formId: this.formDataList[0].jciId, //表单ID
                        salesId: val.salesId, //业务员ID
                    }).then((res) => {
                        if (res && res.status == 200) {
                            let flag = -1;
                            this.dialogList = []
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                flag = this.dialogList.findIndex(
                                    (item) => item.level == 0
                                );
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                this.paramValue(val);
                            }
                        } else {
                            this.clearValue();
                            this.lineMessageBox(res);
                            return false;
                        }
                    }).catch((rej) => {
                        this.clearValue();
                        this.lineMessageBox(rej);
                    });
                } else if (this.seType == "stName") {
                    if (this.stNameFlag) {
                        this.mxParamValue(val);
                    } else {
                        this.paramValue(val);
                        if (this.sendDataInfo.pisOrderDetail.length > 0) {
                            this.sendDataInfo.pisOrderDetail.forEach(item => {
                                item.stName = val.stName
                                item.stId = val.stId
                            })
                        } else {
                            this.$nextTick(() => {
                                this.nextFocus(this.seIndex);
                            });
                        }
                    }
                } else if (this.seType == "coName") {
                    this.paramValue(val);
                    this.parentSearchData.coId = val.coId;
                } else {
                    this.paramValue(val);
                }
            }
        },
        bgmSelect(val) {
            if (
                this.sendDataInfo.pisOrderDetail &&
                this.sendDataInfo.pisOrderDetail.length > 0
            ) {
                var mx = JSON.parse(JSON.stringify(val));
                mx.forEach((item) => {
                    this.$set(item, 'psodPsnvolume', item.stockNum)
                    this.$set(item, 'psodPsdvolume', item.rjXl)
                    this.$set(item, 'psodPsupperlimit', item.limdHighnum)
                    this.$set(item, 'psodPslowerlimit', item.limdLownum)
                })
                this.sendDataInfo.pisOrderDetail.forEach((item, index) => {
                    if (item.bgmId == "" || item.bgmName == "") {
                        this.sendDataInfo.pisOrderDetail.splice(index, 1);
                    }
                });
                mx.forEach((item) => {
                    this.sendDataInfo.pisOrderDetail.push({});
                    for (const key in this.detaislDataInfo) {
                        this.$set(
                            this.sendDataInfo.pisOrderDetail[
                            this.sendDataInfo.pisOrderDetail.length - 1
                            ],
                            key,
                            item[key] != undefined && item[key] != null
                                ? item[key]
                                : ""
                        );
                        if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                            this.$set(this.sendDataInfo.pisOrderDetail[this.sendDataInfo.pisOrderDetail.length - 1], 'stName', this.sendDataInfo.stName);
                            this.$set(this.sendDataInfo.pisOrderDetail[this.sendDataInfo.pisOrderDetail.length - 1], 'stId', this.sendDataInfo.stId);
                        }
                    }
                    this.calculatePrice(5, this.sendDataInfo.pisOrderDetail.length - 1)

                });
            } else {
                this.sendDataInfo.pisOrderDetail = [];
                val.forEach((item, index) => {
                    this.sendDataInfo.pisOrderDetail.push({});
                    for (const key in this.detaislDataInfo) {
                        this.$set(this.sendDataInfo.pisOrderDetail[index], key, item[key] != undefined && item[key] != null ? item[key] : "");
                        if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                            this.$set(this.sendDataInfo.pisOrderDetail[index], 'stName', this.sendDataInfo.stName);
                            this.$set(this.sendDataInfo.pisOrderDetail[index], 'stId', this.sendDataInfo.stId);
                        }

                    }
                    this.calculatePrice(5, index)
                });
            }
            this.selectedDetailsIndex = this.sendDataInfo.pisOrderDetail.length - 1;

        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, flag) {
            console.log(sId, index, type, sField, fField, flag);

            setTimeout(() => {
                this.showDialog = false;
            }, 16.7);
            if (
                type == "salesName" ||
                type == "caiAddress" ||
                type == "recName" ||
                type == "sbiName"
            ) {
                if (this.sendDataInfo.smId == "") {
                    return this.$message({
                        message: "请先选择单位",
                        type: "warning",
                    });
                }
            }
            if (type == "stName") {
                if (flag) {
                    this.stNameFlag = flag
                    this.parentSearchData.stName = this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex].stName;
                } else {
                    this.stNameFlag = false
                    this.parentSearchData.stName = this.sendDataInfo.stName;
                }
            }
            this.DialogVisible = true;
            removeEventListener("keyup", this.keyUp);
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.parentSearchData.stId = this.sendDataInfo.stId;
            this.parentSearchData.cmId = this.sendDataInfo.cmId;
            this.parentSearchData.coId = this.sendDataInfo.coId;
            this.isRepetition = false
            if (type == "bgmName") {
                if (this.sendDataInfo.pisOrderDetail && this.sendDataInfo.pisOrderDetail.length > 0) {
                    this.parentSearchData.bgmName =
                        this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName;
                }
                this.isRepetition = true
                this.isRepetitionList = this.sendDataInfo.pisOrderDetail
                if (this.parentSearchData.bgmName) {
                    let fh = 0;
                    if (this.parentSearchData.bgmName.indexOf(",") != -1) {
                        fh = ",";
                    } else if (this.parentSearchData.bgmName.indexOf("，") != -1) {
                        fh = "，";
                    }
                    if (fh !== 0) {
                        const str = this.parentSearchData.bgmName;
                        const list = str.split(fh);
                        this.parentSearchData.bgmName = list[0] || "";
                        this.parentSearchData.manufacturer = list[1] || "";
                    } else {
                        this.parentSearchData.manufacturer = "";
                    }
                } else {
                    this.parentSearchData.bgmName = "";
                    this.parentSearchData.manufacturer = "";
                }
                return;
            }
            this.parentSearchData[type] = this.sendDataInfo[type];

        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        //新增明细
        addDetail(sendDataInfo) {
            var flag = false;
            if (this.sendDataInfo.pisOrderDetail.length > 0) {
                this.sendDataInfo.pisOrderDetail.forEach((item) => {
                    if (item.bgmId == "") {
                        flag = true;
                        return this.$message({
                            message: "请不要重复新增空白行",
                            type: "warning",
                        });
                    }
                });
            }
            if (flag) {
                return;
            }
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sendDataInfo.pisOrderDetail.push({});
                    var index = this.sendDataInfo.pisOrderDetail.length - 1;
                    for (const key in this.detaislDataInfo) {
                        this.$set(
                            this.sendDataInfo.pisOrderDetail[index],
                            key,
                            this.detaislDataInfo[key]
                        );
                    }
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.pisOrderDetail.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        detailsAction(cate = 0) {
            if (cate == 0) {
                this.editDateilsIndex = "";
                return false;
            }

            var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo));
            if (dataInfo.psodPacknum <= 0) {
                this.$message({
                    message: "请填写采购数量",
                    type: "error",
                });
                return false;
            }
            if (this.editDateilsIndex !== "") {
                this.sendDataInfo.pisOrderDetail.splice(this.editDateilsIndex, 1);
            }
            this.sendDataInfo.pisOrderDetail.push(dataInfo);
            this.editDateilsIndex = "";
        },
        blurwoadPnumber(index) {
            var info = this.sendDataInfo.pisOrderDetail[index];
            this.sendDataInfo.pisOrderDetail[index].psodPacknum = this.$common.getDecimalInfo(
                1,
                info.psodPacknum
            );
        },
        // 计算价格
        calculatePrice(cate, index) {
            var info = this.sendDataInfo.pisOrderDetail[index];
            if (info.psodPacknum <= 0) {
                this.$message({
                    message: "请先填写采购数量",
                    type: "error",
                });
                return false;
            }

            // 缓存常用变量，避免重复访问
            const details = this.sendDataInfo.pisOrderDetail[index];
            const quantity = parseFloat(info.psodPacknum) || 0;
            const taxRate = parseFloat(info.inRate) || 0;
            const price = parseFloat(info.price) || 0;
            const psprice = parseFloat(info.psprice) || 0;
            const psmoney = parseFloat(info.psmoney) || 0;

            // 创建税率计算辅助函数
            const calculateTaxFactor = () => NP.plus(1, NP.divide(taxRate, 100));
            const calculateTaxAdjustedPrice = (basePrice) => this.$common.getDecimalInfo(2, NP.times(basePrice, calculateTaxFactor()));
            const calculateBaseFromTaxed = (taxedValue) => this.$common.getDecimalInfo(3, NP.divide(taxedValue, calculateTaxFactor()));

            switch (cate) {
                case 1: // 单价计算
                    // 计算含税价格 单价+单价*税率/100
                    const taxAdjustedPrice = calculateTaxAdjustedPrice(price);
                    details.psprice = this.$common.getDecimalInfo(2, taxAdjustedPrice);
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
                    } ``
                    // 计算金额 单价*数量
                    details.money = this.$common.getDecimalInfo(3, NP.times(price, quantity));
                    // 计算含税金额 含税价格*数量
                    details.psmoney = this.$common.getDecimalInfo(3, NP.times(taxAdjustedPrice, quantity));
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
                    break;
                case 2: // 含税价格计算
                    // 计算含税金额 含税价格*数量
                    details.psmoney = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(psprice, quantity));
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((info.psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    // 计算金额 含税金额/(税率/100+1)
                    const midmoney = calculateBaseFromTaxed(details.psmoney);
                    details.money = this.$common.getDecimalInfo(3, midmoney);
                    // 计算单价 金额/数量
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, quantity));
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
                    break;
                case 3: // 通过总金额计算
                    // 计算单价  总金额 / 数量
                    const calculatedPrice = quantity ? this.$common.getDecimalInfo(2, NP.divide(info.money, quantity)) : 0;
                    details.price = calculatedPrice;
                    // 计算含税价格 单价+单价*税率/100
                    const taxAdjustedPrice2 = calculateTaxAdjustedPrice(calculatedPrice);
                    details.psprice = this.$common.getDecimalInfo(3, taxAdjustedPrice2);
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    // 计算整件数量
                    details.wholeNum = Math.floor(NP.divide(quantity, Number(info.packingSpec)));

                    //计算零散数量
                    details.scatNum = NP.minus(quantity, NP.times(details.wholeNum, Number(info.packingSpec)));

                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
                    // 计算含税金额 含税价格*数量
                    details.psmoney = this.$common.getDecimalInfo(3, NP.times(taxAdjustedPrice2, quantity));
                    break;
                case 4: // 通过含税金额计算
                    // 计算含税价格  含税金额 / 数量
                    details.psprice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(psmoney, quantity));
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(3, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    // 计算总金额 含税金额/(税率/100+1)
                    const midmoney2 = calculateBaseFromTaxed(psmoney);
                    details.money = this.$common.getDecimalInfo(3, midmoney2);
                    // 计算单价 金额/数量
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney2, quantity));
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(psmoney, details.money));
                    break;
                case 6: //含税原价
                    details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), quantity));
                    details.orMoney = calculateBaseFromTaxed(details.orPsmoney);
                    details.orPrice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide((details.orMoney || 0), quantity));
                    details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((info.psprice || 0), (details.orPsprice || 0)), 100));
                    break;
                case 7: //不含税原价
                    // 计算含税原价 不含税原价+不含税原价*税率/100
                    details.orPsprice = calculateTaxAdjustedPrice(info.orPrice);
                    // 计算含税原价
                    details.orPsprice = this.$common.getDecimalInfo(2, details.orPsprice);
                    //计算含税原金额
                    details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((details.orPsprice || 0), quantity));
                    // 计算不含税原金额
                    details.orMoney = this.$common.getDecimalInfo(3, NP.times((info.orPrice || 0), quantity));
                    //计算折扣率
                    details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((details.psprice || 0), (details.orPsprice || 0)), 100));
                    break;
                default:
                    // 通过数量计算
                    // 计算含税金额 含税价格*数量
                    const midmoney3 = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, quantity));
                    details.psmoney = this.$common.getDecimalInfo(3, midmoney3);
                    // 计算总金额 含税金额/(税率/100+1)
                    details.money = calculateBaseFromTaxed(details.psmoney);
                    // 计算单价 金额/数量
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.money, quantity));
                    // 计算整件数量
                    details.wholeNum = Math.floor(NP.divide(quantity, Number(info.packingSpec)));
                    //计算零散数量
                    details.scatNum = NP.minus(quantity, NP.times(details.wholeNum, Number(info.packingSpec)));
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), quantity));
                        details.orMoney = calculateBaseFromTaxed(details.orPsmoney);
                        details.orPrice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide((details.orMoney || 0), quantity));
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((info.psprice || 0), (details.orPsprice || 0)), 100));
                    }
                    //计算税额
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money));
                    // 计算件数 采数/包装单位
                    if (
                        parseFloat(info.packingSpec) <= 0 ||
                        info.packingSpec == ""
                    ) {
                        details.pieceNum = 0;
                    } else {
                        details.pieceNum = this.$common.getDecimalInfo(
                            1,
                            NP.divide(quantity, info.packingSpec)
                        );
                    }
                    break;
            }
            details.disPrice = this.$common.getDecimalInfo(2, NP.minus(info.disPreprice || 0, info.psprice || 0));
        },
        initActionBox(sendDataInfo) {
            var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
            this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    // this.$parent.getDataList()
                    this.init();
                    this.$refs[sendDataInfo].resetFields();
                })
                .catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "pisOrderAuxinf") {
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = "";
                    }
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            // this.sendDataInfo.psomBuydate = this.$moment().valueOf();

            this.sendDataInfo.pisOrderDetail = [];
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
            this.$set(this.sendDataInfo, "totalAgreementPrice", 0);
            this.sendDataInfo.orderType = 0; //orderType	订单类型0.药品订单1.器械订单
        },

        // 选择采购员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.opmId) {
                    this.sendDataInfo.psomBusdept = item.depId;
                }
            });
        },

        changeFocus() {
            setTimeout(() => {
                var el = document.getElementById("mainInfo");
                var inel = el.getElementsByClassName("el-input__inner");
                for (let index = 0; index < inel.length; index++) {
                    if (inel[index].value == "") {
                        inel[index].focus();
                        break;
                    }
                }
            }, 500);
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            this.filterMainField();
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.parentSearchData.smId = "";
                this.initDefaultValue();
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.smId = dataInfo.smId;
                this.parentSearchData.smId = oldData.smId;
                this.$nextTick(() => {
                    this.selectedDetailsIndex = 0;
                    setTimeout(() => {
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        );
                    }, 16.7);
                });
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.$refs["tree"].init(this.sendDataInfo.psomId);
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.changeFocus();
                }, 16.7);
            });
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (
                    item.defaultValue != "null" &&
                    item.defaultValue != null &&
                    item.defaultValue != ""
                ) {
                    this.sendDataInfo[item.entityField] = item.defaultValue;
                }
            });
            this.sendDataInfo.isPay = Number(this.sendDataInfo.isPay);
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms);
            this.sendDataInfo.isMag = Number(this.sendDataInfo.isMag);

            this.sendDataInfo.psomBuydate = this.$moment().valueOf();
            this.sendDataInfo.psaiDeptime = this.$moment().valueOf();
            this.sendDataInfo.psaiExptime = this.$moment().valueOf();
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                    this.mxForm.jurconfigform.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                    // 底部增加"总协议价"合计显示（明细协议价agreementPrice*采购数量累加）
                    const agreementIndex = this.footForm.findIndex((val) => val.entityField == "totalAgreementPrice");
                    if (agreementIndex == -1) {
                        const agreementItem = {
                            chineseField: "总协议金额",
                            entityField: "totalAgreementPrice",
                            isShow: 1,
                        };
                        const totalMoneyIndex = this.footForm.findIndex((val) => val.entityField == "totalMoney");
                        totalMoneyIndex > -1 ? this.footForm.splice(totalMoneyIndex + 1, 0, agreementItem) : this.footForm.push(agreementItem);
                    } else {
                        this.footForm[agreementIndex].isShow = 1;
                    }
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (
                        key.jurconfigform[index].isShow == 1 ||
                        key.jurconfigform[index].entityField == "sbiName" ||
                        key.jurconfigform[index].entityField == "sbiNumber"
                    )
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            this.tabForm.forEach(item => {
                var index = 0
                item.jurconfigform.forEach((val, key) => {
                    if (val.isShow == 1) {
                        val.isIndex = index
                        index++
                    }
                })
            })
            var arr = [{ entityField: "pisOrderDetail" }];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }

            this.$set(this.sendDataInfo, "orderType", 0); //订单类型0.药品订单1.器械订单
        },
        //确认新增
        sendDataAction(formName1) {
            let flag = false;
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    if (this.sendDataInfo.pisOrderDetail.length < 1) {
                        this.$message({
                            message: "请添加采购订单明细",
                            type: "error",
                        });
                        return;
                    } else {
                        var index2 = this.sendDataInfo.pisOrderDetail.findIndex(val => val.bgmId == "" || val.bgmId == null)
                        if (index2 != -1) {
                            this.sendDataInfo.pisOrderDetail.splice(index2, 1)
                        }
                        var flagNum = false
                        var flag = false
                        var indexNum = 0
                        var indexNum1 = 0
                        this.sendDataInfo.pisOrderDetail.forEach((item, index) => {
                            if ((item.psodPacknum == "" || item.psodPacknum == null || item.psodPacknum <= 0) && !flagNum) {
                                indexNum1 = index
                                flagNum = true
                            }
                            if ((item.psprice == "" || item.psprice == null || item.psprice <= 0) && (item.psmoney == "" || item.psmoney == null || item.psmoney <= 0) && (item.price == "" || item.price == null || item.price <= 0) && (item.money == "" || item.money == null || item.money <= 0)) {

                            } else if (item.psprice > 0 && item.psmoney > 0 && item.price > 0 && item.money > 0) {

                            } else if (!flag) {
                                indexNum = index
                                flag = true
                            }
                        })
                        if (flagNum) {
                            return this.$message.error(`第${indexNum1 + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum1].bgmName}数量不能为空或为零！`)
                        }
                        if (flag) {
                            return this.$message.error(`第${indexNum + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum].bgmName}（含税价格、含税金额、价格、金额）有为零的请检查！`)
                        }
                        this.sendDataInfo.pisOrderDetail.forEach((item, index) => {
                            if (item.bgmId == "" || item.bgmId == null) {
                                this.sendDataInfo.pisOrderDetail.splice(index, 1);
                            }
                        });
                        this.sendDataInfo.totalCount = this.sendDataInfo.pisOrderDetail.length
                        // 使用reduce方法计算每个id的出现次数  
                        const idCounts = this.sendDataInfo.pisOrderDetail.reduce((acc, obj) => {
                            acc[obj.bgmId] = (acc[obj.bgmId] || 0) + 1;
                            return acc;
                        }, {});
                        // 过滤出出现次数超过一次的id  
                        const duplicateIds = Object.keys(idCounts).filter(id => idCounts[id] > 1);
                        if (duplicateIds.length > 0) {
                            this.$confirm("存在相同商品是否提交？", "提示", {
                                confirmButtonText: "确定",
                                cancelButtonText: "取消",
                                type: "warning",
                            }).then(() => {
                                this.sub();
                            }).catch(() => { });
                        } else {
                            this.sub();
                        }
                    }
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
        },
        async sub() {
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addPurchaseOrder(
                    this.sendDataInfo
                );
            } else {
                var responseData = await this.$http.setPurchaseOrder(
                    this.sendDataInfo
                );
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        deleteDetails() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                this.isTiQu = false;
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
                return false;
            }

            this.sendDataInfo.pisOrderDetail.splice(this.selectedDetailsIndex, 1);
            if (this.sendDataInfo.pisOrderDetail.length > 1) {
                this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
            } else {
                this.selectedDetailsIndex = 0;
            }
            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
                this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
            );
        },
        // 复制
        copyDetails() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                return this.$message({
                    message: "暂无可复制明细",
                    type: "warning",
                });
                return false;
            } else {
                this.sendDataInfo.pisOrderDetail.push(
                    JSON.parse(
                        JSON.stringify(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        )
                    )
                );
            }
        },

        // 判断是不是采购员
        checkIsBuyer() {
            if (this.dataActionBox.actionType != 0) return;
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            let ormInfo = JSON.parse(sessionStorage.getItem("ormInfo"));
            if (ormInfo.isDefaultopm == 1) {
                if (info.opmBuyer == 1) {
                    this.isBuyer = 1;
                    this.sendDataInfo.depName = info.depName;
                    this.sendDataInfo.depId = info.depId;
                    this.sendDataInfo.opmName = info.opmName;
                    this.sendDataInfo.opmId = info.opmId;
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "opmName" ||
                            item.entityField == "depName"
                        )
                            item.isChange = 0;
                    });
                }
            }
        },
        // 监听键盘事件
        keyUp(e) {
            console.log(e.key);
            if (e.key == "F1") {
                // 右键新增明细
                e.preventDefault();
                this.addDetail("sendDataInfo");
                return;
            } else if (e.key == "F2" || e.key == "Delete") {
                e.preventDefault();
                this.deleteDetails();
            } else if (e.key == "F4" && this.dataActionBox.actionType != 2) {//保存
                this.sendDataAction('sendDataInfo')
            } else if (e.keyCode == 40) {
                // 下键
                // 表格为空，不执行下方
                if (this.sendDataInfo.pisOrderDetail.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (
                        this.selectedDetailsIndex ==
                        this.sendDataInfo.pisOrderDetail.length - 1
                    ) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedDetailsIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            } else if (e.keyCode == 38) {
                // 上键
                if (this.sendDataInfo.pisOrderDetail.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (this.selectedDetailsIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex =
                            this.sendDataInfo.pisOrderDetail.length - 1;
                    } else {
                        // 正常递减
                        this.selectedDetailsIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
            this.checkIsBuyer();
            this.isLoaded = true;
        });

        this.$dbCache.Record_Get(4).then((res) => {//选择明细后不允许更换单位
            //明细拦截
            let obj = res
            if (obj.isEnable == 1) this.detailRules = true;
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        setTimeout(() => {
            this.getMainInput();
        }, 16.7);
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.v-modal {
    position: static !important;
    width: 100%;
    height: 100%;
    background: transparent;
}

::v-deep .el-alert__content {
    width: 100%;
}
</style>